if (!customElements.get('gi-nylatech-ordering')) {
  class GiNylatechOrdering extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.lengths = JSON.parse(this.querySelector('[data-gi-lengths]').textContent);
      this.setVariant(this.dataset.selectedId);
      this.cuts = this.querySelector('[data-gi-cuts]');
      const wrapper = this.closest('.thb-product-detail');
      wrapper?.addEventListener('input', () => this.updateCutRequirement());
      wrapper?.addEventListener('change', () => this.updateCutRequirement());
      this.updateCutRequirement();
    }

    setVariant(id) {
      if (!this.initialized) return;
      this.length = this.lengths[String(id)];
      const display = this.querySelector('[data-gi-length]');
      const property = this.querySelector('[data-gi-length-property]');
      if (display) display.textContent = this.length == null ? '—' : Number(this.length);
      if (property) {
        property.value = this.length == null ? '' : Number(this.length);
        property.disabled = this.length == null;
      }
    }

    updateCutRequirement() {
      if (!this.cuts || this.dataset.unit !== 'SFT') return;
      const form = document.getElementById(this.dataset.formId);
      const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
      this.cuts.required = quantity % 8 !== 0;
    }

    requestDetails() {
      return { unit: this.dataset.unit, length: this.length == null ? null : Number(this.length), cuts: this.cuts?.value.trim() || '' };
    }
  }
  customElements.define('gi-nylatech-ordering', GiNylatechOrdering);
}
